export const formatStringArrayToColumn = (arr) => {
  if (!arr || !Array.isArray(arr)) return null;
  return arr.filter(Boolean).join(', ');
};

export const formatBooleanToYesNo = (t) => (booleanValue) => {
  if (!booleanValue) return null;
  return t(`booleanToYesNo.${booleanValue}`);
};
